import { home_i18n } from "./views/empresa/home.js";
import { login_i18n } from "./views/auth/login";
import { register_i18n } from "./views/auth/register.js";
import { app_i18n } from "./views/appWeb.js";
import { footer_i18n } from "./views/footer.js";
import { listbookings } from "./views/empresa/ListBookings.js";
import { checkinmanual } from "./views/empresa/checkinmanual.js";
import { enviarcheckin } from "./views/empresa/enviarcheckin.js";
import { servicios } from "./views/empresa/servicios.js";
import { propiedades } from "./views/empresa/propiedades.js";
import { upsellings } from "./views/empresa/upsellings.js";
import { integraciones } from "./views/empresa/integraciones.js";
import { facturacion } from "./views/empresa/facturacion.js";
import { profile } from "./views/empresa/profile.js";
import { maqueta } from "./views/empresa/maqueta.js";
import { noti } from "./views/empresa/noti.js";
import { reservas } from "./views/empresa/reservas.js";
import { nav } from "./views/empresa/nav.js";
import { account } from "./views/empresa/account.js";
import { settingAccommodation } from "./views/empresa/settingAccommodation.js";
import { suscription } from "./views/empresa/suscription.js";
import { notifications } from "../en/views/empresa/notifications.js";
import { chatbot } from "./views/empresa/chatbot.js";
import { alloggiati } from "./views/empresa/alloggiati.js";
import { ross1000 } from "./views/empresa/ross1000.js";

// Archivos nuevos para las traducciones
import { dashboard } from "./views/dashboard";
import { aiAgent } from "./views/aiAgent.js";
import { listingDetail } from "./views/listingDetail.js";
import { managementExpenses } from "./views/managementExpenses.js";
import { gestionAnalytics } from "./views/gestionAnalytics.js";
import { ownerSettlement } from "./views/ownerSettlement.js";
import { settlementAdjustment } from "./views/settlementAdjustment.js";
import { rangoFechas } from "./views/rangoFechas.js";
import { scheduledMessages } from "./views/scheduledMessages.js";
import { otaNet } from "./views/otaNet.js";
import { otaCommissions } from "./views/otaCommissions.js";
import { listingManager } from "./views/listingManager.js";
import { voiceAgent } from "./views/voiceAgent.js";
import { referrals } from "./views/referrals.js";
import { plans } from "./views/plans.js";
import { setupOnboarding } from "./views/setupOnboarding.js";
import { unitFaq } from "./views/unitFaq.js";
import { agentPlayground } from "./views/agentPlayground.js";
import { cloneControl } from "./views/cloneControl.js";
import { dashInvoices } from "./views/dashInvoices.js";
import { agentRequests } from "./views/agentRequests.js";
import { dashHome } from "./views/dashHome.js";
import { reservationDrawer } from "./views/reservationDrawer.js";
import { listingConfigDrawer } from "./views/listingConfigDrawer.js";
import { pendingBookings } from "./views/pendingBookings.js";
import { checkinEditDrawer } from "./views/checkinEditDrawer.js";
import { chargeServicesDrawer } from "./views/chargeServicesDrawer.js";
import { bulkCalendarDrawer } from "./views/bulkCalendarDrawer.js";
import { housekeepingDrawer } from "./views/housekeepingDrawer.js";
import { housekeepingProtocol } from "./views/housekeepingProtocol.js";
import { navigation } from "./views/navigation.js";
import { sidebar } from "./views/sidebar.js";
import { voiceCalls } from "./views/voiceCalls.js";
import { booking } from "./views/booking.js";
import { modal } from "./views/modal.js";
import { calendar } from "./views/calendar.js";
import { channel } from "./views/channel.js";
import { property } from "./views/property.js";
import { bot } from "./views/bot.js";
import { subscription } from "./views/subscription.js";
import { stripe } from "./views/stripe.js";
import { services} from "./views/services.js";
import { inbox } from "./views/inbox.js";
import { iframes } from "./views/iframes.js";
import { calendarHotel } from './views/calendarHotel';

import { accountMenu } from "./views/accountMenu.js";
import { cloneConfigModal } from "./views/cloneConfigModal.js";
import { availabilityPrices } from "./views/availabilityPrices.js";
import { reservationConversations } from "./views/reservationConversations.js";
import { dynamicPricing } from "./views/dynamicPricing.js";
import { reservasPanels } from "./views/reservasPanels.js";
import { reservasModals } from "./views/reservasModals.js";
import { propInfo } from "./views/propInfo.js";
import { propRules } from "./views/propRules.js";
import { propFaqBooking } from "./views/propFaqBooking.js";
import { propMisc } from "./views/propMisc.js";
import { imageAccommodation } from "./views/imageAccommodation.js";
import { hotelRoomsManager } from "./views/hotelRoomsManager.js";
import { listingRatesManager } from "./views/listingRatesManager.js";
import { priceSeasons } from "./views/priceSeasons.js";
import { hotelRatesManager } from "./views/hotelRatesManager.js";
import { derivedRatesSection } from "./views/derivedRatesSection.js";
import { stayPromotions } from "./views/stayPromotions.js";
import { lockTypeConfig } from "./views/lockTypeConfig.js";
import { tedeeConfig } from "./views/tedeeConfig.js";
import { ttlockConfig } from "./views/ttlockConfig.js";
import { shellyConfig } from "./views/shellyConfig.js";
import { yacanConfig } from "./views/yacanConfig.js";
import { akiles } from "./views/akiles.js";
import { dbTabs1 } from "./views/dbTabs1.js";
import { dbTabs2 } from "./views/dbTabs2.js";
import { dbPanels } from "./views/dbPanels.js";
import { ratePlansTab } from "./views/ratePlansTab.js";
import { additionalChargesTab } from "./views/additionalChargesTab.js";
import { listingBookingSettings } from "./views/listingBookingSettings.js";
import { globalPromotionsManager } from "./views/globalPromotionsManager.js";
import { globalServicesManager } from "./views/globalServicesManager.js";
import { apartmentsGlobalSettings } from "./views/apartmentsGlobalSettings.js";
import { webEmbedTab } from "./views/webEmbedTab.js";
import { checkinModalGlobal } from "./views/checkinModalGlobal.js";
import { checkinList } from "./views/checkinList.js";
import { checkinModalConversation } from "./views/checkinModalConversation.js";
import { checkinMisc } from "./views/checkinMisc.js";
import { managerUsers } from "./views/managerUsers.js";
import { authScreens } from "./views/authScreens.js";
import { templateComps } from "./views/templateComps.js";
import { website } from "./views/website.js";
import { accountSetup } from "./views/accountSetup.js";
import { billingConfiguration } from "./views/billingConfiguration.js";
import { paymentAccounts } from "./views/paymentAccounts.js";
import { monedaAnuncio } from "./views/monedaAnuncio.js";
import { datafono } from "./views/datafono.js";
import { clientesDir } from "./views/clientesDir.js";
import { accountComponents } from "./views/accountComponents.js";
import { mensajesInbox } from "./views/mensajesInbox.js";
import { invoiceList } from "./views/invoiceList.js";
import { manualInvoiceModal } from "./views/manualInvoiceModal.js";
import { reservationInvoicePanel } from "./views/reservationInvoicePanel.js";
import { templatesIndex } from "./views/templatesIndex.js";
import { selectedCountry } from "./views/selectedCountry.js";
import { analytics } from "./views/analytics.js";
import { teamManagement } from "./views/teamManagement.js";
import { directBookingsSettingsView } from "./views/directBookingsSettingsView.js";
import { otaConnectWizard } from "./views/otaConnectWizard.js";
import { modalReservationDirect } from "./views/modalReservationDirect.js";
import { setupWizard } from "./views/setupWizard.js";
import { guestComps } from "./views/guestComps.js";
import { bookingCharges } from "./views/bookingCharges.js";
import { housekeeping } from "./views/housekeeping.js";
import { calendarModals } from "./views/calendarModals.js";
import { hourlyCalendar } from "./views/hourlyCalendar.js";
import { accomMgmt } from "./views/accomMgmt.js";
import { syncCalendar } from "./views/syncCalendar.js";
import { accountViews } from "./views/accountViews.js";
import { appViews } from "./views/appViews.js";
import { mensajesChat } from "./views/mensajesChat.js";
import { sitesWebMisc } from "./views/sitesWebMisc.js";
import { invoicesMisc } from "./views/invoicesMisc.js";
import { channelOta } from "./views/channelOta.js";
import { managerPrices } from "./views/managerPrices.js";
import { managerMisc } from "./views/managerMisc.js";
import { dashboardWidgets } from "./views/dashboardWidgets.js";
import { propMiscModals } from "./views/propMiscModals.js";
import { layoutsMisc } from "./views/layoutsMisc.js";
import { maquetaTpl } from "./views/maquetaTpl.js";
import { tailMisc } from "./views/tailMisc.js";
import { propPoliciesRoomsHc } from "./views/propPoliciesRoomsHc.js";
import { upsellingHc } from "./views/upsellingHc.js";
import { propAuthLocksHc } from "./views/propAuthLocksHc.js";
import { hotelCalendarHc } from "./views/hotelCalendarHc.js";
import { propCreateHc } from "./views/propCreateHc.js";
import { reservasHc } from "./views/reservasHc.js";
import { billingProfileHc } from "./views/billingProfileHc.js";
import { miscTailHc } from "./views/miscTailHc.js";
import { bookingsHc } from "./views/bookingsHc.js";
import { reservasSmallHc } from "./views/reservasSmallHc.js";
import { sitesChannelHc } from "./views/sitesChannelHc.js";
import { calendarsChatbotHc } from "./views/calendarsChatbotHc.js";
import { tourNovedades } from "./views/tourNovedades.js";
import { hcExtra } from "./views/hcExtra.js";
import { dominioPropio } from "./views/dominioPropio.js";
export const pl_i18n = {
  hcExtra: hcExtra,
  calendarsChatbotHc: calendarsChatbotHc,
  tourNovedades: tourNovedades,
  sitesChannelHc: sitesChannelHc,
  reservasSmallHc: reservasSmallHc,
  bookingsHc: bookingsHc,
  miscTailHc: miscTailHc,
  billingProfileHc: billingProfileHc,
  reservasHc: reservasHc,
  propCreateHc: propCreateHc,
  hotelCalendarHc: hotelCalendarHc,
  propAuthLocksHc: propAuthLocksHc,
  upsellingHc: upsellingHc,
  propPoliciesRoomsHc: propPoliciesRoomsHc,
  tailMisc: tailMisc,
  maquetaTpl: maquetaTpl,
  layoutsMisc: layoutsMisc,
  propMiscModals: propMiscModals,
  dashboardWidgets: dashboardWidgets,
  managerMisc: managerMisc,
  managerPrices: managerPrices,
  channelOta: channelOta,
  invoicesMisc: invoicesMisc,
  sitesWebMisc: sitesWebMisc,
  mensajesChat: mensajesChat,
  appViews: appViews,
  accountViews: accountViews,
  syncCalendar: syncCalendar,
  accomMgmt: accomMgmt,
  calendarModals: calendarModals,
  hourlyCalendar: hourlyCalendar,
  housekeeping: housekeeping,
  bookingCharges: bookingCharges,
  guestComps: guestComps,
  setupWizard: setupWizard,
  modalReservationDirect: modalReservationDirect,
  otaConnectWizard: otaConnectWizard,
  directBookingsSettingsView: directBookingsSettingsView,
  teamManagement: teamManagement,
  analytics: analytics,
  selectedCountry: selectedCountry,
  templatesIndex: templatesIndex,
  reservationInvoicePanel: reservationInvoicePanel,
  manualInvoiceModal: manualInvoiceModal,
  invoiceList: invoiceList,
  mensajesInbox: mensajesInbox,
  accountComponents: accountComponents,
  billingConfiguration: billingConfiguration,
  paymentAccounts: paymentAccounts,
  monedaAnuncio: monedaAnuncio,
  datafono: datafono,
  clientesDir: clientesDir,
  accountSetup: accountSetup,
  website: website,
  templateComps: templateComps,
  authScreens: authScreens,
  managerUsers: managerUsers,
  checkinMisc: checkinMisc,
  checkinModalConversation: checkinModalConversation,
  checkinList: checkinList,
  checkinModalGlobal: checkinModalGlobal,
  webEmbedTab: webEmbedTab,
  apartmentsGlobalSettings: apartmentsGlobalSettings,
  globalPromotionsManager: globalPromotionsManager,
  globalServicesManager: globalServicesManager,
  listingBookingSettings: listingBookingSettings,
  additionalChargesTab: additionalChargesTab,
  ratePlansTab: ratePlansTab,
  dbPanels: dbPanels,
  dbTabs2: dbTabs2,
  dbTabs1: dbTabs1,
  yacanConfig: yacanConfig,
  akiles: akiles,
  shellyConfig: shellyConfig,
  ttlockConfig: ttlockConfig,
  tedeeConfig: tedeeConfig,
  lockTypeConfig: lockTypeConfig,
  stayPromotions: stayPromotions,
  derivedRatesSection: derivedRatesSection,
  hotelRatesManager: hotelRatesManager,
  listingRatesManager: listingRatesManager,
  priceSeasons: priceSeasons,
  hotelRoomsManager: hotelRoomsManager,
  imageAccommodation: imageAccommodation,
  propMisc: propMisc,
  propFaqBooking: propFaqBooking,
  propRules: propRules,
  propInfo: propInfo,
  reservasModals: reservasModals,
  reservasPanels: reservasPanels,
  dynamicPricing: dynamicPricing,
  reservationConversations: reservationConversations,
  availabilityPrices: availabilityPrices,
  cloneConfigModal: cloneConfigModal,
  accountMenu: accountMenu,
  alloggiati: alloggiati,
  ross1000: ross1000,
  aiAgent: aiAgent,
  listingDetail: listingDetail,
  managementExpenses: managementExpenses,
  gestionAnalytics: gestionAnalytics,
  ownerSettlement: ownerSettlement,
  settlementAdjustment: settlementAdjustment,
  rangoFechas: rangoFechas,
  scheduledMessages: scheduledMessages,
  otaNet: otaNet,
  otaCommissions: otaCommissions,
  listingManager: listingManager,
  voiceAgent: voiceAgent,
  referrals: referrals,
  plans: plans,
  setupOnboarding: setupOnboarding,
  unitFaq: unitFaq,
  agentPlayground: agentPlayground,
  cloneControl: cloneControl,
  dashInvoices: dashInvoices,
  agentRequests: agentRequests,
  dashHome: dashHome,
  reservationDrawer: reservationDrawer,
  listingConfigDrawer: listingConfigDrawer,
  pendingBookings: pendingBookings,
  checkinEditDrawer: checkinEditDrawer,
  chargeServicesDrawer: chargeServicesDrawer,
  bulkCalendarDrawer: bulkCalendarDrawer,
  housekeepingDrawer: housekeepingDrawer,
  housekeepingProtocol: housekeepingProtocol,
  dashboard: dashboard,
  navigation: navigation,
  sidebar: sidebar,
  voiceCalls: voiceCalls,
  channel: channel,
  booking: booking,
  modal: modal,
  calendar: calendar,
  property: property,
  subscription: subscription,
  bot: bot,
  stripe: stripe,
  services: services,
  inbox: inbox,
  iframes: iframes,
  calendarHotel: calendarHotel,
  dominioPropio: dominioPropio,
  empresa: {
    home: home_i18n,
    listbookings: listbookings,
    checkinmanual: checkinmanual,
    enviarcheckin: enviarcheckin,
    servicios: servicios,
    propiedades: propiedades,
    upsellings: upsellings,
    integraciones: integraciones,
    facturacion: facturacion,
    profile: profile,
    maqueta: maqueta,
    noti: noti,
    reservas: reservas,
  },
  lg: {
    nav: nav,
    account:account,
    acc: settingAccommodation,
    sus: suscription,
    nt: notifications,
    chatbot: chatbot,
  },
  auth: {
    login: login_i18n,
    register: register_i18n,
  },
  footer: {
    t: footer_i18n,
  },
  app: {
    t: app_i18n,
  },
};
